import { Controller } from "@hotwired/stimulus"

// Shows a "please specify" field beside a select while its "Other" option is chosen (TMS-1760),
// and hides it again otherwise. Works for single and multiple selects (components/select): it
// listens for the select's `app-select:change`. Radios work too, through their own `change`: the
// practice step's clinical questions show while "Do you see patients?" is Yes (TMS-1761). The
// hidden fields are disabled so they aren't posted, and the server drops the text whenever Other
// is not chosen anyway.
export default class extends Controller {
  static targets = ["details"]
  static values = { other: { type: String, default: "other" } }

  change(event) {
    const values = event.detail?.values ?? [event.detail?.value ?? event.target.value]
    this.toggle(values.map(String).includes(this.otherValue))
  }

  toggle(show) {
    this.detailsTarget.hidden = !show
    this.detailsTarget.querySelectorAll("input, textarea, button").forEach((field) => { field.disabled = !show })
    this.element.dispatchEvent(new CustomEvent("other-choice:change", { bubbles: true }))
  }
}
